import { render } from "./WorkList.vue?vue&type=template&id=4db89f4c&scoped=true"
import script from "./WorkList.vue?vue&type=script&lang=js"
export * from "./WorkList.vue?vue&type=script&lang=js"

import "./WorkList.vue?vue&type=style&index=0&id=4db89f4c&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4db89f4c"]])

export default __exports__